import axios from 'axios';
import { BASE_API_URL } from '@/lib/constants';
import { getFingerprint } from '@/services/fingerprintService';

const url = BASE_API_URL;

const axiosInstance = axios.create({
  baseURL: url,
});

// Agregar interceptor para incluir el fingerprint en todas las peticiones
axiosInstance.interceptors.request.use(async (config) => {
  try {
    const fingerprint = await getFingerprint();
    config.headers['x-device-fp'] = fingerprint;
  } catch (error) {
    console.error('Error al asignar fingerprint en header:', error);
  }
  return config;
}, (error) => Promise.reject(error));

export default axiosInstance;

export const axiosPrivate = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true
});

// Agregar el mismo interceptor para axiosPrivate
axiosPrivate.interceptors.request.use(async (config) => {
  try {
    const fingerprint = await getFingerprint();
    config.headers['x-device-fp'] = fingerprint;
  } catch (error) {
    console.error('Error al asignar fingerprint en header:', error);
  }
  return config;
}, (error) => Promise.reject(error));
